import React from 'react';
import { createRoot } from 'react-dom/client';
import Quiz from './Quiz';
import './styles/index.scss';

/**
 * Fira Sans is NOT loaded here.
 *
 * The old build pulled it from Google Fonts with webfontloader. The theme
 * already self-hosts the family (wp-content/themes/toneheim-theme/assets/fonts/
 * firasans-*), and the quiz renders inside a theme page, so the face is already
 * available — the Google request was a duplicate and a third-party dependency
 * on every quiz page view.
 */

const container = document.getElementById('root');

if (container) {
  createRoot(container).render(<Quiz />);
}
